import config from "./config";
var axios = config();

export default {
  getStudentRequest(id) {
    return axios.get("/api/StudentRequests/GetStudentRequestById", {
      params: { id: id }
    });
  },

  getStudentRequests() {
    return axios.get("/api/StudentRequests/GetStudentRequestsActive", {
      params: {}
    });
  },

  getStudentRequestsForUser() {
    return axios.get("/api/StudentRequests/GetStudentRequestsForUser", {
      params: {}
    });
  },

  getStudentRequestsByStudent(asurite) {
    return axios.get("/api/StudentRequests/GetStudentRequestsByStudent", {
      params: { asurite: asurite }
    });
  },

  postStudentRequest(request) {
    return axios.post("/api/StudentRequests/PostStudentRequest", request);
  },

  postContractRequest(siteId) {
    return axios.post("/api/StudentRequests/PostContractRequest", siteId);
  },

  postStudentRequestApproval(request) {
    return axios.post(
      "/api/StudentRequests/PostStudentRequestApproval",
      request
    );
  },

  postStudentRequestSiteApproval(request) {
    return axios.post(
      "/api/StudentRequests/PostStudentRequestSiteApproval",
      request
    );
  },

  postStudentRequestContractApproval(request) {
    return axios.post(
      "/api/StudentRequests/PostStudentRequestContractApproval",
      request
    );
  },

  postFinalizeStudentRequest(request) {
    return axios.post(
      "/api/StudentRequests/PostFinalizeStudentRequest",
      request
    );
  }
};
